export default __webpack_public_path__ + "static/media/gallery-big-mario.833aaf4c.webp";